import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_275: DocMigration = {
  maxSchemaVersion: "0.0.275",
  description: "Correct the settingsHandle id property for annotation templates",
  apply(json: any) {
    for (const settingsId in json.settings) {
      const setting = json.settings[settingsId];

      if (setting.type !== "ANNOTATION_CATALOG_SETTINGS") {
        continue;
      }

      if (!Object.keys(setting.annotationTemplates ?? {}).length) {
        continue;
      }

      for (const annotationTemplateId in setting.annotationTemplates) {
        const annotationTemplate = setting.annotationTemplates[annotationTemplateId];

        annotationTemplate.handle.settingsHandle = {
          type: "SETTINGS",
          id: setting.id,
        };

        if (annotationTemplate.handle.templateId) {
          annotationTemplate.handle.annotationTemplateId = annotationTemplate.handle.templateId;
          delete annotationTemplate.handle.templateId;
        }

        for (const componentId in annotationTemplate.components) {
          const component = annotationTemplate.components[componentId];

          const { annotationTemplateHandle } = component.handle;

          if (annotationTemplateHandle.templateId) {
            annotationTemplateHandle.annotationTemplateId = annotationTemplateHandle.templateId;
            delete annotationTemplateHandle.templateId;
          }

          annotationTemplateHandle.settingsHandle = {
            type: "SETTINGS",
            id: setting.id,
          };
        }
      }
    }

    return json;
  },
};

export default migration_0_0_275;
